export default __webpack_public_path__ + "static/media/MDV_6.ddf72b45.png";